<template>
  <div class="fullScreen">
    <div id="FindPhonePwd">
      <div class="loginWrap">
        <div class="logoTitle">
          <img class="logo"
               src="@/assets/images/footballAssociation.png"
               alt="">
          <img class="title"
               src="@/assets/images/title_picture.png"
               alt="">
        </div>
        <div class="loginBox">
          <img class="bgBox" src="@/assets/images/bgbox.png"/>
          <div class="warnBox"  v-if="stepFlag && !success">
            <el-tooltip content="提示：学员和讲师用户名为身份有效证件号" placement="bottom-end" effect="light">
              <img src="@/assets/images/warn-message.png" alt="">
            </el-tooltip>
          </div>
          <div class="boxTop">
            <template v-if="stepFlag">
              <h4>通过用户名重置密码</h4>
              <router-link to="/login">返回登录</router-link>
            </template>
            <template v-else>
              <h4>通过手机号重置密码</h4>
              <a v-if="!success"
                 href="javascript:void(0);"
                 @click="preStep">返回上一步</a>
            </template>
          </div>
          <div class="boxCenter" v-if="!success">
            <template v-if="stepFlag">
              <div class="step">
                <div :class="{mobile_phone: true, borderFocus: user_nameFocus, errBorder: user_nameErr}">
                  <div :class="{icon: true, iconFocus: user_nameFocus}">
                    <v-icon name="user" scale="1"></v-icon>
                  </div>
                  <input v-model.trim="user_name"
                         placeholder="请输入您的用户名"
                         @focus="user_nameInputFocus"
                         @blur="user_nameInputBlur">
                  <div class="tips" v-show="user_nameFlag">{{ user_nameMsg }}</div>
                </div>
                <div class="wrap">
                  <div :class="{code: true, borderFocus: vcodeFocus, errBorder: vcodeErr}">
                    <div :class="{icon: true, iconFocus: vcodeFocus}">
                      <v-icon name="shield-alt" scale="1"></v-icon>
                    </div>
                    <input v-model.trim="verification_code"
                           placeholder="请输入验证码"
                           @focus="vcodeInputFocus"
                           @blur="vcodeInputBlur">
                    <div class="tips" v-show="vcodeFlag">{{ vcodeMsg }}</div>
                  </div>
                </div>
                <div class="code-wrap">
                  <img :src="verificationBase64"  v-show="!showLoading"
                    @load="showLoading=false" style="height:40px;width:160px" >
                  <div class="loadImgIng"  v-show="showLoading">
                    <i class="el-icon-loading loading-code" ></i>
                  </div>
                  <div class="refresh-code" @click="refreshCode">看不清，换一张验证码</div>
                </div>
                <div class="loginBtn" @click="nextStep">下一步</div>
                <div class="boxTip">温馨提示：密码重置成功后，请使用新的密码登录</div>
              </div>
            </template>
            <template v-else>
              <div :class="{mobile_phone: true, borderFocus: mobile_phoneFocus, errBorder: mobile_phoneErr}">
                <div :class="{icon: true, iconFocus: mobile_phoneFocus}">
                  <v-icon name="user" scale="1"></v-icon>
                </div>
                <input v-model.trim="mobile_phone"
                       placeholder="请输入手机号"
                       @focus="mobile_phoneInputFocus"
                       @blur="mobile_phoneInputBlur"
                       :disabled="true">
                <div class="tips" v-show="mobile_phoneFlag">{{ mobile_phoneMsg }}</div>
                <el-popover
                  placement="right"
                  title="解决办法"
                  width="400"
                  trigger="hover"
                  popper-class="method_no_code"
                >
                  <p>1: 如果您正在培训期间需要更换手机号，请通过培训班协调员联系培训组织协会修改。</p>
                  <p>2: 如果您已经更换了手机号码，请您使用本人在系统个人资料中填写的电子邮箱发送修改前后的手机号和个人身份证信息到songmh@yioks.com，身份确认后将会在三个工作日内更改您系统默认手机号，默认手机号修改完成后您再使用“忘记密码”功能重新设置系统密码。</p>
                  <div class="get_none_code get_none_phone" slot="reference" >手机号码已更换？</div>
                </el-popover>
              </div>
              <div class="wrap">
                <div :class="{code: true, borderFocus: codeFocus, errBorder: codeErr}">
                  <div :class="{icon: true, iconFocus: codeFocus}">
                    <v-icon name="shield-alt" scale="1"></v-icon>
                  </div>
                  <input v-model.trim="code"
                         placeholder="请输入验证码"
                         @focus="codeInputFocus"
                         @blur="codeInputBlur">
                  <div class="tips" v-show="codeFlag">{{ codeMsg }}</div>

                </div>
                <div v-if="codeBtnFlag"
                     class="sendCodeBtn sendCode"
                     @click="sendcode">发送验证码
                </div>
                <div v-else
                     class="sendCodeBtn noCode">{{sec}}秒后重新发送
                </div>
                <el-popover
                        placement="right"
                        title="解决办法"
                        width="400"
                        trigger="hover"
                        popper-class="method_no_code"
                        >
                  <p>1: 通讯异常会造成短信发送延时或者丢失，请尝试重新获取短信验证码；</p>
                  <p>2: 查看垃圾短信，是否被短信过滤软件拦截；</p>
                  <p>3: 请确认手机号码是否正确，手机是否欠费；</p>
                  <p>4: 关机后重新启动手机，重新加载手机和基站的通信链路；</p>
                  <p>5: 如果您正在培训期间需要更换手机号，请通过培训班协调员联系培训组织协会修改；</p>
                  <p>6: 如果您正在培训期间发现初始手机号显示错误需要更换手机号，请通过培训班协调员联系培训组织协会修改；</p>
                  <p>7: 联系电话客服；</p>
                  <div class="get_none_code" slot="reference" >收不到验证码？</div>
                </el-popover>
              </div>
              <div :class="{pwd: true, borderFocus: pwdFocus, errBorder: pwdErr}">
                <div :class="{icon:true, iconFocus: pwdFocus}">
                  <v-icon name="lock" scale="1"></v-icon>
                </div>
                <input v-model.trim="pwd"
                       type="password"
                       placeholder="请输入8—16位字母和数字组合"
                       @focus="pwdInputFocus"
                       @blur="pwdInputBlur">
                <div class="tips" v-show="pwdFlag">{{ pwdMsg }}</div>
              </div>
              <div :class="{affirm_pwd: true, borderFocus: affirm_pwdFocus, errBorder: affirm_pwdErr}">
                <div :class="{icon:true, iconFocus: affirm_pwdFocus}">
                  <v-icon name="lock" scale="1"></v-icon>
                </div>
                <input v-model.trim="affirm_pwd"
                       type="password"
                       placeholder="请确认新密码"
                       @focus="affirm_pwdInputFocus"
                       @blur="affirm_pwdInputBlur">
                <div class="tips" v-show="affirm_pwdFlag">{{ affirm_pwdMsg }}</div>
              </div>
              <div class="loginBtn" @click="check">重置密码</div>
              <div class="boxTip">温馨提示：密码重置成功后，请使用新的密码登录</div>
            </template>
          </div>
          <div class="boxCenter" v-if="success">
            <div class="success">
              <div class="tips">
                <i class="el-icon-success"></i>
                <p>密码修改成功 !</p>
              </div>
              <div class="tips-btn" @click="goLogin">
                <span v-text="second"></span>
                <span>s后立即登录</span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <app-footer></app-footer>
  </div>
</template>

<script>
  import "vue-awesome/icons/user";
  import "vue-awesome/icons/lock";
  import "vue-awesome/icons/check";
  import "vue-awesome/icons/shield-alt";
  import {getFindSalt, getFindSendCode, getFindPhone, getMobileInfo} from "@/api/common/login";
  import {hex_hmac_sha256} from "@/assets/js/sha";
  import {getPhotoCode} from "@/api/common/achievement";
  import commonFun from "@/assets/js/yioks";
  const { uuid } = commonFun;

  export default {
    name: "FindPhonePwd",
    data() {
      return {
        repeatSubmit: false,
        mobile_phoneFocus: false,
        codeFocus: false,
        pwdFocus: false,
        affirm_pwdFocus: false,
        mobile_phoneErr: false,
        codeErr: false,
        pwdErr: false,
        affirm_pwdErr: false,
        mobile_phoneFlag: false,
        codeFlag: false,
        pwdFlag: false,
        affirm_pwdFlag: false,
        mobile_phoneMsg: "",
        codeMsg: "",
        pwdMsg: "",
        affirm_pwdMsg: "",
        mobile_phone: "",
        code: "",
        pwd: "",
        affirm_pwd: "",
        codeBtnFlag: true,
        sec: 60,
        stepFlag: true,
        user_name: "",
        user_nameFlag: false,
        user_nameFocus: false,
        user_nameErr: false,
        user_nameMsg: "",
        vcodeFocus: false,
        vcodeErr: false,
        vcodeFlag: false,
        vcodeMsg: "",
        nextFlag: false,
        userInfo: {},
        identifyCodes: "0123456789",
        identifyCode: "",
        success: false,
        second: 5,
        verificationBase64:'',
        showLoading: true,
        nonce_str: '',
        verification_code:''
      };
    },
    components: {
      "v-icon": () => import("vue-awesome/components/Icon"),
      "app-footer": () => import("@/components/LayOut/Common/Footer"),
      "verify-code": () => import("@/components/VerifyCode/identify"),
    },
    created() {
      const info = this.$route.query.info;
      if(info) {
        this.userInfo = JSON.parse(decodeURIComponent(info));
        this.mobile_phone = this.userInfo.mobile_phone;
        this.stepFlag = false;
      }
      this.nonce_str = uuid();
      this.refreshCode();
    },
    methods: {
      mobile_phoneInputFocus() {
        this.mobile_phoneFocus = true;
        this.mobile_phoneErr = false;
        this.mobile_phoneFlag = false;
      },
      mobile_phoneInputBlur() {
        this.mobile_phoneFocus = false;
        if (!this.$yioks.mobile_phone(this.mobile_phone)) {
          this.mobile_phoneErr = true;
          this.mobile_phoneFlag = true;
          this.mobile_phoneMsg = "请输入有效的11位手机号";
        } else {
          this.mobile_phoneErr = false;
          this.mobile_phoneFlag = false;
          this.mobile_phoneMsg = "";
        }
      },
      codeInputFocus() {
        this.codeFocus = true;
        this.codeErr = false;
        this.codeFlag = false;
      },
      codeInputBlur() {
        this.codeFocus = false;
        if (!this.$yioks.code(this.code)) {
          this.codeErr = true;
          this.codeFlag = true;
          this.codeMsg = "请输入有效的验证码";
        } else {
          this.codeErr = false;
          this.codeFlag = false;
          this.codeMsg = "";
        }
      },
      pwdInputFocus() {
        this.pwdFocus = true;
        this.pwdErr = false;
        this.pwdFlag = false;
      },
      pwdInputBlur() {
        this.pwdFocus = false;
        if (!this.$yioks.pwd(this.pwd)) {
          this.pwdErr = true;
          this.pwdFlag = true;
          this.pwdMsg = "8—16位字母（区分大小写）和数字组合";
        } else {
          if (this.affirm_pwd !== "") {
            // 如果确认密码不为null触发验证
            this.affirm_pwdInputBlur();
          } else {
            this.pwdErr = false;
            this.pwdFlag = false;
            this.pwdMsg = "";
          }
        }
      },
      affirm_pwdInputFocus() {
        this.affirm_pwdFocus = true;
        this.affirm_pwdErr = false;
        this.affirm_pwdFlag = false;
      },
      affirm_pwdInputBlur() {
        this.affirm_pwdFocus = false;
        if (!this.$yioks.pwd(this.affirm_pwd)) {
          this.affirm_pwdErr = true;
          this.affirm_pwdFlag = true;
          this.affirm_pwdMsg = "8—16位字母（区分大小写）和数字组合";
        } else {
          if (this.affirm_pwd !== this.pwd) {
            // 如何两个密码不同
            this.affirm_pwdErr = true;
            this.affirm_pwdFlag = true;
            this.affirm_pwdMsg = "两次输入密码不一致!";
          } else {
            this.affirm_pwdErr = false;
            this.affirm_pwdFlag = false;
            this.affirm_pwdMsg = "";
          }
        }
      },
      check() {
        if (this.repeatSubmit) return false;
        this.repeatSubmit = true;
        // 触发失去焦点事件
        // this.mobile_phoneInputBlur();
        this.codeInputBlur();
        this.pwdInputBlur();
        this.affirm_pwdInputBlur();
        if (
          this.mobile_phoneErr ||
          this.codeErr ||
          this.pwdErr ||
          this.affirm_pwdErr
        ) {
          this.repeatSubmit = false;
          return false;
        }
        this.FindSalt();
      },
      FindSalt() {
        getFindSalt({uid: this.userInfo.uid})
          .then(res => {
            // console.log(res);
            if(Number(res.data.status) === 0) {
              const {salt} = res.data.result;
              const pwd = hex_hmac_sha256(salt, this.pwd).toUpperCase();
              const affirm_pwd = hex_hmac_sha256(
                salt,
                this.affirm_pwd
              ).toUpperCase();
              this.FindPhone(pwd, affirm_pwd);
              return false;
            }
            throw new Error(res);
          })
          .catch(err => {
            this.repeatSubmit = false;
            console.error(err);
          });
      },
      FindPhone(pwd, affirm_pwd) {
        getFindPhone({
          uid: this.userInfo.uid,
          code: this.code,
          pwd: pwd,
          affirm_pwd: affirm_pwd
        })
          .then(res => {
            // console.log(res);
            this.repeatSubmit = false;
            if (Number(res.data.status) === 0) {
              this.$message.success("密码重置成功，请重新登录~");
              /** 调整登录页面 */
              // this.$router.push("/login");
              this.success = true;
              this.beforeGoLogin();
              return;
            }
            if (Number(res.data.status) === 109) {
              /** 验证码错误 */
              this.codeErr = true;
              this.codeFlag = true;
              this.codeMsg = res.data.msg;
            } else if (Number(res.data.status) === 101 ||  Number(res.data.status) === 407) {
              /** 用户不存在 */
              this.mobile_phoneErr = true;
              this.mobile_phoneFlag = true;
              this.mobile_phoneMsg = res.data.msg;
            } else {
              this.affirm_pwdErr = true;
              this.affirm_pwdFlag = true;
              this.affirm_pwdMsg = res.data.msg;
            }
          })
          .catch(err => {
            this.repeatSubmit = false;
            console.error(err);
          });
      },
      countdown() {
        this.codeBtnFlag = false;
        const timer = setInterval(() => {
          this.sec = this.sec - 1;
          if (this.sec === 0) {
            this.sec = 60;
            this.codeBtnFlag = true;
            clearInterval(timer);
          }
        }, 1000);
      },
      sendcode() {
        // 触发手机号失去焦点事件
        /*this.mobile_phoneInputBlur();
        if (this.mobile_phoneErr) {
          return;
        }*/
        getFindSendCode({uid: this.userInfo.uid})
          .then(res => {
            // console.log(res);
            this.codeFocus = false;
            if (res.data.status == 0) {
              this.$message.success("验证码发送成功");
              this.codeErr = false;
              this.codeFlag = false;
              this.mobile_phoneErr = false;
              this.mobile_phoneFlag = false;
              this.mobile_phoneMsg = ''
              /* 倒计时 */
              this.countdown();
            }else if (res.data.status == 407){
              this.mobile_phoneErr = true;
              this.mobile_phoneFlag = true;
              this.mobile_phoneMsg = res.data.msg;;
            }
            else {
              this.codeErr = true;
              this.codeFlag = true;
              this.codeMsg = res.data.msg;
            }
          })
          .catch(err => {
            console.error(err);
          });
      },
      user_nameInputFocus() {
        this.user_nameFocus = true;
        this.user_nameErr = false;
        this.user_nameFlag = false;
      },
      user_nameInputBlur() {
        this.user_nameFocus = false;
        if(this.user_name === "") {
          this.user_nameErr = true;
          this.user_nameFlag = true;
          this.user_nameMsg = "请输入您的用户名";
        }else{
          this.user_nameErr = false;
          this.user_nameFlag = false;
          this.user_nameMsg = "";
        }
      },
      vcodeInputFocus() {
        this.vcodeFocus = true;
        this.vcodeErr = false;
        this.vcodeFlag = false;
      },
      vcodeInputBlur() {
        this.vcodeFocus = false;
        if(this.verification_code === "") {
          this.vcodeErr = true;
          this.vcodeFlag = true;
          this.vcodeMsg = "请输入有效的验证码";
        } else {
          this.vcodeErr = false;
          this.vcodeFlag = false;
          this.vcodeMsg = "";
        }
      },
      resetForm() {
        this.stepFlag = false;
        this.codeErr = false;
        this.codeFlag = false;
        this.pwdErr = false;
        this.pwdFlag = false;
        this.affirm_pwdErr = false;
        this.affirm_pwdFlag = false;
        this.code = "";
        this.pwd = "";
        this.affirm_pwd = "";
      },
      preStep() {
        this.stepFlag = true;
        this.refreshCode();
        this.$router.replace({
          path: this.$route.path,
          query: {}
        });
      },
      nextStep() {
        if(this.nextFlag) return false;
        this.nextFlag = true;
        this.user_nameInputBlur();
        this.vcodeInputBlur();
        if(!(this.user_nameErr || this.vcodeErr)) {
          getMobileInfo({
            username: this.user_name,
            nonce_str:this.nonce_str,
            verification_code:this.verification_code
          })
            .then(({ data }) => {
              const status = Number(data.status);
              if(status === 0) {
                const info = data.result.user_info;
                this.userInfo = info;
                this.mobile_phone = info.mobile_phone;
                this.resetForm();
                this.$router.replace({
                  path: this.$route.path,
                  query: {
                    info: encodeURIComponent(JSON.stringify(info))
                  }
                });
              }else if(status === 510){
                this.vcodeErr = true;
                this.vcodeFlag = true;
                this.vcodeMsg = data.msg;
                this.refreshCode();
              }else{
                this.user_nameErr = true;
                this.user_nameFlag = true;
                this.user_nameMsg = data.msg;
                this.refreshCode();
              }
              // 用户名不存在
//              if(status === 101 || status === 407 ||  status === 520 ||  status === 435 || status ===548 ||  status === 538) {
//                this.user_nameErr = true;
//                this.user_nameFlag = true;
//                this.user_nameMsg = data.msg;
//              }
              this.nextFlag = false;
            })
            .catch((err) => {
              this.nextFlag = false;
              console.error(err);
            });
        } else {
          this.nextFlag = false;
          this.refreshCode();
        }
      },
      // 生成一个随机数
      randomNum (min, max) {
        return Math.floor(Math.random() * (max - min) + min);
      },
      refreshCode () {
        this.showLoading = true;
        getPhotoCode({nonce_str: this.nonce_str, timestamp: new Date().getTime()})
        .then((res) => {
          if (Number(res.data.status) === 0) {
            this.verificationBase64 = res.data.result.verificationBase64;
          } else {
            this.$message.error(res.data.msg);
          }
          this.showLoading=false
        })
        .catch((err) => {
          this.verificationBase64='error.jpg';
          this.showLoading=false
        });
      },
      makeCode (o, l) {
        for (let i = 0; i < l; i++) {
          this.identifyCode += this.identifyCodes[this.randomNum(0, this.identifyCodes.length)];
        }
      },
      goLogin() {
        this.$router.replace({
          path: "/login",
          query: {}
        });
      },
      beforeGoLogin() {
        let timer = setInterval(() => {
          if(this.second === 0) {
            clearInterval(timer);
            this.goLogin();
            return false;
          }
          this.second = this.second - 1;
        }, 1000);
      },
    },
    mounted () {
      this.identifyCode = '';
      this.makeCode(this.identifyCodes, 4);
    }
  };
</script>

<style lang="stylus" scoped>
  @import '~@/assets/css/variable';
  .fullScreen {
    width: 100%;
    height: 100%;
  }

  #FindPhonePwd {
    height: calc(100% - 60px);
    display: flex;
    justify-content: center;
    user-select: none;

    .loginWrap {
      width: 1024px;
      padding: 95px 0 0;
      display: flex;
      flex-direction: column;

      .logoTitle {
        display: flex;
        justify-content: center;
        align-items: center;
        margin: 0 0 100px 0;

        .logo {
          width: 120px;
          height: 120px;
          margin: 0 15px 0 0;
        }
      }

      .loginBox {
        align-self: flex-end;
        width: 480px;
        height: 490px;
        padding: 24px 24px 0 24px;
        background-color: $block_bg_color_base;
        box-shadow: 2px 2px 2px rgba(0, 0, 0, 0.2);
        position: relative;
        .bgBox {
          position: absolute;
          left: -57px;
          width: 150px;
          top: -80px;
          z-index: 100;
        }
        .warnBox{
          position absolute;
          right 75px
          top 132px
          cursor pointer
          z-index 100
        }
        .boxTop {
          padding: 0 0 20px 0;
          display: flex;
          justify-content: space-between;
          align-items: center;
          font-size: 20px;
          color: #fff;
          border-bottom: 1px solid $color_white;

          a {
            font-size: 16px;
            color: $color_suc;
            &:hover {
              color: $color_suc;
            }
          }
        }

        .boxCenter {
          padding: 20px 40px;
          .wrap {
            display: flex;
            position relative
            .code {
              input {
                max-width: 170px;
              }
            }
            .sendCodeBtn {
              flex: 1 1 auto;
              height: 36px;
              display: flex;
              justify-content: center;
              align-items: center;
              margin: 2px 0 35px 10px;
              color: $color_white;
              padding: 0 10px;
            }
            .sendCode {
              background: $color_suc;
              cursor: pointer;
            }
            .noCode {
              background-color: $color_info;
              cursor: not-allowed;
            }
            .get_none_code{
              position absolute
              bottom 8px
              cursor pointer
              right 0
              color $color_white
            }
          }
          .get_none_phone{
            position absolute
            top 45px
            cursor pointer
            right 0
            color $color_white
          }


          .mobile_phone, .code, .pwd, .affirm_pwd {
            margin: 0 0 35px;
            display: flex;
            border: 2px solid;
            position: relative;

            .tips {
              position: absolute;
              left: 0;
              bottom: -30px;
              color: $color_err;
              font-size: $font_size_small;
            }

            .icon {
              width: 36px;
              height: 36px;
              display: flex;
              justify-content: center;
              align-items: center;
              color: #ceced2;
              background-color: $color_white;
              border-right: 1px solid #ceced2;
            }

            .iconFocus {
              color: $color_suc;
            }

            input {
              padding: 0 10px;
              flex: 1 1 auto;
              color: #3e3e3e;
              font-size: $font_size_base;
              line-height: 1.4;
              outline: none;
            }
          }

          .borderFocus {
            border: 2px solid $color_suc;
            box-shadow: 0px 0px 5px 1px $color_suc;
          }

          .errBorder {
            border: 2px solid $color_err;
          }

          .loginBtn {
            height: 40px;
            margin: 0 0 17px;
            display: flex;
            justify-content: center;
            align-items: center;
            font-size: $font_size_medium;
            color: $color_white;
            background-color: $color_suc;
            cursor: pointer;
          }

          .boxTip {
            font-size: 16px;
            color: #dddddd;
          }
          .step {
            padding: 30px 0;
            .mobile_phone, .code {
              margin: 0 0 40px;
            }
            .loginBtn {
              margin: 0 0 30px;
            }
            .wrap {
              .code {
                input {
                  max-width: 100%;
                  width: 312px;
                }
              }
            }
            .code-wrap {
              margin: 0 0 35px 0;
              display: flex;
              justify-content: space-between;
              .loadImgIng{
                background-color #fff
                width 160px
                height 40px
                text-align center
                color black
                font-size 30px
              }
              .refresh-code {
                flex: 1 1 auto;
                margin: 0 0 0 10px;
                padding: 0 10px;
                display: flex;
                justify-content: center;
                align-items: center;
                color: $color_white;
                background-color: $color_suc;
                cursor: pointer;
              }
            }
          }
          .success {
            text-align: center;
            .tips {
              padding: 50px 0 0;
              .el-icon-success {
                color: $color_suc;
                font-size: 80px;
              }
              p {
                margin: 30px 0 0;
                color: $color_white;
                font-size: 25px;
              }
            }
            .tips-btn {
              margin: 50px 0 0;
              padding: 10px 0;
              color: $color_white;
              font-size: $font_size_big;
              background-color: $color_suc;
              cursor: pointer;
            }
          }
        }
      }
    }
  }
  @media screen and (max-width: 1024px) {
    #FindPhonePwd {
      .loginWrap {
        .loginBox {
          margin: 0 100px 0 0;
        }
      }
    }
  }
</style>

<style lang="stylus">
  .method_no_code{
    .el-popover__title{
      border-bottom 1px solid black
      padding-bottom 2px
    }
  }
</style>
